import { FunctionComponent, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSimpleSpinner } from "../../../reducers/spinnerReducer";

const SuspenseSpinner: FunctionComponent = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setSimpleSpinner(true));

        return () => {
            dispatch(setSimpleSpinner(false));
        };
    }, []);

    return null;
};

export default SuspenseSpinner;
